const getters = {
  permissions: state => state.account.permissions,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js